<div class="container">
  <div class="text-container">
    <div>
      <img width="205px" src="../../../../../assets/Primary-dark.svg" alt="" />
    </div>

    <!-- TO DO -->

  </div>

</div>
